/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as transectionService from '../../../services/transectionService'
import * as userService from '../../../services/userService'
import { BASE_IMAGE_PATH } from '../../../configs/api';
import { OPERATOR_ID } from '../../../configs/const';
import * as utils from '../../../util/string.util';
class RGWithdrawModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            amount: null,
            remark: "",
            mpassword: "",
            toastMsg: "",
            toastType: "",
            clientBalance: "",
            afterClientBalance: 0,
            currUserData: {},
            currUserBalance: "",
            afterCurrUserBalance: 0,
            loading: false
        };
    }
    
    async componentDidMount() {
        let currUserData;
        currUserData = localStorage.getItem("userAccData")
        currUserData = JSON.parse(currUserData)
        let masterDetail = await userService.getRealGamesUserBalance(currUserData.userId);
        let clientDetail = await userService.getRealGamesUserBalance(this.props.user.userId);//await userService.getRealGamesUsersByUserName(this.props.user.username)
        // if (this.props.user.role === "Client"){
        //     let avail = clientDetail.availableBalance
        //     avail = avail + clientDetail.upLineBalance + clientDetail.exposure
        //     clientDetail.availableBalance = avail
        // } // as asked by rinkal
        this.setState({ currUserData: currUserData, currUserBalance: utils.toFixedDigit(parseFloat(!!masterDetail.availableBalance ? masterDetail.availableBalance : 0)), afterCurrUserBalance: utils.toFixedDigit(parseFloat(!!masterDetail.availableBalance ? masterDetail.availableBalance : 0)), clientBalance: utils.toFixedDigit(parseFloat(!!clientDetail.availableBalance ? clientDetail.availableBalance : 0)) })
    }

    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }

    handleKey(e) {
        if (e.keyCode === 13) {
            this.submitData();
        }
    }

    async submitData() {
        if (this.state.loading) {
            return false
        } else {
            this.setState({ loading: true }, async () => {
                if (!!this.state.amount && 0 <= this.state.afterClientBalance) {
                    let data = {
                        "userId": !!this.state.clientDetail && !!this.state.clientDetail.userId.split(":")[0] ? this.state.clientDetail.userId : this.props.user.userId,
                        "amount" : parseFloat(this.state.amount),
                        "description": this.state.remark
                    }
                    await transectionService.realGamesWithdraw(data).then((res) => {
                        
                        if (res.isSuccess) {
                            this.props.notify("Withdraw amount successfully!", "success");
                            setTimeout(() => {this.setState({ loading: false }); this.props.closeAndUpdate()}, 2000)
                        } else {
                            this.props.notify(res.message);
                            this.setState({ loading: false })
                        }
                    })
                } else {
                    this.setState({ loading: false })
                }
            })
        }
    }

    change(e) {
        const name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value })
    }

    onAmountChange(e) {
        const name = e.target.name;
        let value = e.target.value;
        if (value) {
            let afterCurrUserBalance = this.state.currUserBalance
            afterCurrUserBalance = afterCurrUserBalance + parseFloat(value)
            let afterClientBalance = this.state.clientBalance
            afterClientBalance = afterClientBalance - parseFloat(value)
            this.setState({ [name]: value, afterCurrUserBalance: afterCurrUserBalance, afterClientBalance: afterClientBalance })
        }
        else {
            // this.setState({ [name]: value, afterCurrUserBalance: 0, afterClientBalance: 0 })
            this.setState({ [name]: value, afterCurrUserBalance: utils.toFixedDigit(parseFloat(!!this.state.currUserBalance ? this.state.currUserBalance : 0)), afterClientBalance: utils.toFixedDigit(parseFloat(!!this.state.clientBalance ? this.state.clientBalance : 0)) })
        }
    }
    render() {
        return (
            <>
                <div className="modal fade show" style={{ display: 'block' }} id="mywithdraw" role="dialog" aria-modal="true">
                    <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Club Games Withdraw</h4>
                                <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                            </div>
                            <div className="modal-body lst-pop pt-0">
                                <div className="row tab-hide">
                                    <div className="col-md-8">
                                    </div>
                                    <div className="col-md-4">
                                        <label className="deposite-user-first mb-0 pl-1">After</label>
                                    </div>
                                </div>
                                <div className="row m-b-20">
                                    <div className="col-md-4">
                                        <label className="deposite-user-first">My Available</label>
                                    </div>
                                    <div className="col-md-4">
                                        <span className="popup-box wid-98" id="deposite-first">{!!this.state.currUserBalance ? this.state.currUserBalance : "0.00"}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="deposite-user-first mb-0 pl-1 dd-hide">After</label>
                                        <span className="popup-box wid-98" id="deposite-first">{!!this.state.afterCurrUserBalance ? this.state.afterCurrUserBalance : 0}</span>
                                    </div>
                                </div>
                                <div className="row m-b-20">
                                    <div className="col-md-4">
                                        <label className="deposite-user-first">{this.props.user.username}</label>
                                    </div>
                                    <div className="col-md-4">
                                        <span className="popup-box wid-98" id="deposite-first">{!!this.state.clientBalance ? this.state.clientBalance : "0"}</span>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="deposite-user-first mb-0 pl-1 dd-hide">After</label>
                                        <span className="popup-box wid-98" id="deposite-first">{!!this.state.afterClientBalance ? this.state.afterClientBalance : 0}</span>
                                    </div>
                                </div>
                                <div className="row m-b-20">
                                    <div className="col-md-4">
                                        <label>Amount</label>
                                    </div>
                                    <div className="col-md-8">
                                        <input type="number" autoFocus tabIndex={1} name="amount" onChange={(e) => { this.onAmountChange(e) }} className="maxlength10" value={this.state.amount} />
                                    </div>
                                </div>
                                <div className="row m-b-20">
                                    <div className="col-md-4">
                                        <label>Remarks</label>
                                    </div>
                                    <div className="col-md-8">
                                        <textarea name="remark" tabIndex={2} id="deposit-remark" onChange={(e) => { this.change(e) }} value={this.state.remark}></textarea>
                                    </div>
                                </div>
                                {/* <div className="row m-b-20">
                                    <div className="col-md-4">
                                        <label>Master Password</label>
                                    </div>
                                    <div className="col-md-8">
                                        <input type="Password" tabIndex={3} name="mpassword" id="mpassword" onKeyUp={(e) => { this.handleKey(e) }} onChange={(e) => { this.change(e) }} required="" />
                                    </div>
                                </div> */}
                                {(!!this.state.amount && !!this.state.afterClientBalance) && 0 > this.state.afterClientBalance &&
                                    <div className="row m-b-20">
                                        <div className="col-md-12 text-center">
                                            <span className="text-red">Insufficient Balance</span>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="modal-footer">
                                <button onDoubleClickCapture={(e) => { e.preventDefault(); return false; }} disabled={(parseFloat(this.state.amount) !== 0 && this.state.amount !== "" && this.state.amount !== null) ? false : true} onClick={() => this.submitData() } style={{ cursor: "pointer" }} tabIndex={4} className="pop-edit-btn">Submit {this.state.loading && <img alt="" style={{ height: "16px" }} src={BASE_IMAGE_PATH + "/images/loader.gif"} />}</button>
                                &nbsp;&nbsp;
                                <a className="pop-edit-btn" tabIndex={5} style={{ cursor: "pointer" }} onClick={() => { this.props.closePopup() }} data-dismiss="modal">Cancel</a>
                            </div>
                            {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(RGWithdrawModel);